module.exports = __webpack_public_path__ + "static/media/background.e64620ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/MobileNav/background.png
// module id = 602
// module chunks = 0